module.exports = __webpack_public_path__ + "img/visa3-logo.af4a5956.svg";